<mat-form-field [formGroup]="form" appearance="outline" color="primary" class="timepicker">
  <mat-label>{{this.label}}</mat-label>
  <input matInput [readonly]="this.readonly" [matTimepicker]="picker" [id]="this.key" [formControlName]="this.key"
      [name]="this.key" [disabled]="this.disabled || this.readonly || false">
    <mat-timepicker-toggle matIconSuffix [for]="picker" [disabled]="this.readonly"/>
  <mat-timepicker #picker/>
</mat-form-field>